module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_06.jpg?v=3d85cdeb";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_06.jpg
 ** module id = 63
 ** module chunks = 1 2
 **/